import { Product } from "../types";
import ProductCardSmall from "./product-card-small";

export function RecentlyViewed({ products }: { products: Product[] }) {
  if (products.length === 0) return null;
  return (
    <div className="hp-my-4">
      <div className="hp-mb-2 hp-text-lg hp-font-semibold">
        Continue where you left
      </div>
      <div className="flex justify-center gap-x-2 md:gap-x-4"></div>
      <div className="no-scrollbar hp-flex hp-snap-mandatory hp-overflow-x-auto">
        {products.map((product) => {
          return <ProductCardSmall product={product} />;
        })}
      </div>
    </div>
  );
}

export default RecentlyViewed;
